import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import UserRestServices from '../../services/user-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';

@Component({
	standalone: true,
	selector: 'modal-switch-to-patient',
	templateUrl: './modal-switch-to-patient.component.html',
	imports: [ CommonModule, LowerCasePipe, TranslatePipe, LoaderOverlayComponent, ReactiveFormsModule ]
})
export class ModalSwitchToPatientComponent implements OnInit {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private dialogRef = inject(MatDialogRef<ModalSwitchToPatientComponent>);
	private data = inject(MAT_DIALOG_DATA);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	vm: any = undefined;
	consentForm: FormGroup;
	
	constructor(private fb: FormBuilder) {
		this.vm = this;
		this.consentForm = this.fb.group({
			consent1: [false, Validators.requiredTrue],
			consent2: [false, Validators.requiredTrue]
		});
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleModalSubmit = this.handleModalSubmit;
	}
	
	handleModalInit() {
		this.vm.user = this.session.getSession().user;
		var origin: any = (this.vm.user && this.vm.user.origin) ? this.vm.user.origin : "minudoc.ee";
		var locale: any = this.vm.user?.deviceLanguage;
		this.vm.webUrl = this.config.getPublicWebUrl();
		if (origin == 'minudoc.ee') {
			switch (this.vm.user.deviceLanguage) {
				case 'et_EE':
				this.vm.webPathTos = '/kasutustingimused';
				this.vm.webPathPP = '/privaatsuspoliis';
				break;
				case 'ru_RU':
				this.vm.webPathTos = '/uslovija-ispolzovanija';
				this.vm.webPathPP = '/politika-konfidencialnosti';
				break;
				case 'fi_FI':
				this.vm.webPathTos = '/kayttoehdot';
				this.vm.webPathPP = '/tietosuojakaytanto';
				break;
				default:
				this.vm.webPathTos = '/terms-of-service';
				this.vm.webPathPP = '/privacy-policy';
			}
		} else {
			this.vm.webPathTos = '/terms-of-service';
			this.vm.webPathPP = '/privacy-policy';
		}
		this.vm.webTosLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathTos)
			: this.vm.webUrl + this.vm.webPathTos;
		this.vm.webPPLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathPP)
			: this.vm.webUrl + this.vm.webPathPP;
		this.vm.ppConsent = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Modal.Content.HaveRead')
				.replace('%s', '<a href="' + this.vm.webPPLink +'" target="_blank">' + this.angularFilterHelperService.translate('Modal.Content.PrivacyPolicy') + '</a>')
		);
		this.vm.tosConsent = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Modal.Content.AgreeTo')
				.replace('%s', '<a href="' + this.vm.webTosLink +'" target="_blank">' + this.angularFilterHelperService.translate('Modal.Content.ToS') + '</a>')
		);
	}
	
	handleModalSubmit() {
		if (!this.consentForm.valid) {
			this.consentForm.markAllAsTouched();
			return;
		}
		if (this.vm.processing) return;
		this.vm.processing = true;
		
		this.userRestServices.toggleRole().then(
			() => {
				window.location.href = window.location.href.split('#')[0];
			},
			(error) => {
				console.error('Failed updating user consents', error);
				this.vm.processing = false;
			}
		);
	}
	
	handleModalClose() {
		this.dialogRef.close(this.vm.user);
	}
	
}
